import { render, staticRenderFns } from "./datos-generales-acreditaciones.vue?vue&type=template&id=5b42d242&"
import script from "./datos-generales-acreditaciones-component.ts?vue&type=script&lang=ts&"
export * from "./datos-generales-acreditaciones-component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports